const bblCode = window.config.bblCode.toLowerCase()

const checksStageEnvironment = () => {
  if (bblCode.includes('stage')) return true
  return false
}

export const isStageEnvironment = checksStageEnvironment()
